import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/workWx/banner.png';
import _imports_1 from '@/assets/img/workWx/banner2.png';
import _imports_2 from '@/assets/img/workWx/material1-h5.png';
import _imports_3 from '@/assets/img/workWx/material1.png';
import _imports_4 from '@/assets/img/workWx/material2.png';
import _imports_5 from '@/assets/img/workWx/material2-h5.png';
import _imports_6 from '@/assets/img/workWx/material3-h5.png';
import _imports_7 from '@/assets/img/workWx/material3.png';
import _imports_8 from '@/assets/img/workWx/material4.png';
import _imports_9 from '@/assets/img/workWx/material4-h5.png';
const _withScopeId = n => (_pushScopeId("data-v-948ae362"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "workWx"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "banner hidden-xs-only",
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "banner hidden-sm-and-up",
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text hidden-xs-only"
}, "业内领先的公域+私域营销一体化闭环解决方案", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text hidden-sm-and-up"
}, [/*#__PURE__*/_createTextVNode("业内领先的公域"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("+私域营销一体化闭环解决方案")], -1));
const _hoisted_6 = {
  class: "list"
};
const _hoisted_7 = {
  class: "title"
};
const _hoisted_8 = {
  class: "intro"
};
const _hoisted_9 = ["src"];
const _hoisted_10 = ["src"];
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"customer bg-blue mt-70\" data-v-948ae362><div data-v-948ae362><div data-v-948ae362><div class=\"title\" data-v-948ae362>全域获客</div><div data-v-948ae362>客户秒变微信好友，全面提升企业私域获客效率</div></div><img src=\"" + _imports_2 + "\" class=\"hidden-sm-and-up\" alt=\"\" width=\"725\" height=\"829\" style=\"margin-top:20px;\" data-v-948ae362><div class=\"cus-list\" data-v-948ae362><div data-v-948ae362>智能加粉</div><div data-v-948ae362>打通主流电商平台，订单触发加粉；组合AI电话等多种方式进行实时场景化引流，转化率提升400%</div></div><div class=\"cus-list\" data-v-948ae362><div data-v-948ae362>多场景活码引流</div><div data-v-948ae362>支持渠道码、分流活码、群活码、引流短链等，为来自不同渠道、地理位置的客户定制分时段欢迎语和员工分配策略</div></div><div class=\"cus-list\" data-v-948ae362><div data-v-948ae362>社群拓客</div><div data-v-948ae362>结合品类特征，精准匹配社群资源，快速与社群团长建立合作</div></div></div><img src=\"" + _imports_3 + "\" class=\"hidden-xs-only\" alt=\"\" width=\"856\" height=\"573\" data-v-948ae362></div><div class=\"customer bg-white\" data-v-948ae362><img src=\"" + _imports_4 + "\" class=\"hidden-xs-only\" alt=\"\" width=\"873\" height=\"628\" data-v-948ae362><div data-v-948ae362><div data-v-948ae362><div class=\"title\" data-v-948ae362>私域留存与促活</div><div data-v-948ae362>用户洞察与精细化运营，实现成本增效</div></div><img src=\"" + _imports_5 + "\" class=\"hidden-sm-and-up\" alt=\"\" width=\"725\" height=\"783\" style=\"margin-top:20px;\" data-v-948ae362><div class=\"cus-list\" data-v-948ae362><div data-v-948ae362>深度洞察客户</div><div data-v-948ae362>基于OneID对客户全域行为进行追踪，基于行业经验，AI自动挖掘用户属性、行为及偏好，预置丰富的行业标签</div></div><div class=\"cus-list\" data-v-948ae362><div data-v-948ae362>丰富的营销玩法</div><div data-v-948ae362>拉新、转化、促活、复购、裂变，面面俱到</div></div><div class=\"cus-list\" data-v-948ae362><div data-v-948ae362>灵活触达客户</div><div data-v-948ae362>企微群发、朋友圈、AI电话、短信等多渠道灵活触达用户</div></div></div></div><div class=\"customer bg-blue\" data-v-948ae362><div data-v-948ae362><div data-v-948ae362><div class=\"title\" data-v-948ae362>精准营销转化</div><div data-v-948ae362>行业自动化标签及分层，一键应用实现精准营销</div></div><img src=\"" + _imports_6 + "\" class=\"hidden-sm-and-up\" alt=\"\" width=\"727\" height=\"744\" style=\"margin-top:20px;\" data-v-948ae362><div class=\"cus-list\" data-v-948ae362><div data-v-948ae362>策略模板</div><div data-v-948ae362>使用预置人群分层及营销策略模版，站在行业最佳实践肩膀之上开启营销之旅</div></div><div class=\"cus-list\" data-v-948ae362><div data-v-948ae362>智能营销</div><div data-v-948ae362>基于大数据分群，围绕关键营销时刻配置智能营销计划，轻松实现定向人群的自动化营销</div></div><div class=\"cus-list\" data-v-948ae362><div data-v-948ae362>客户运营SOP</div><div data-v-948ae362>轻松配置客户/客户群旅程，将新老客的生命周期运营实现标准化、自动化、常态化</div></div></div><img src=\"" + _imports_7 + "\" class=\"hidden-xs-only\" alt=\"\" width=\"849\" height=\"631\" data-v-948ae362></div><div class=\"customer bg-white\" data-v-948ae362><img src=\"" + _imports_8 + "\" class=\"hidden-xs-only\" alt=\"\" width=\"927\" height=\"657\" data-v-948ae362><div data-v-948ae362><div data-v-948ae362><div class=\"title\" data-v-948ae362>社群互动裂变</div><div data-v-948ae362>充分利用社交属性，使社群价值最大化</div></div><img src=\"" + _imports_9 + "\" class=\"hidden-sm-and-up\" alt=\"\" width=\"725\" height=\"665\" style=\"margin-top:20px;\" data-v-948ae362><div class=\"cus-list\" data-v-948ae362><div data-v-948ae362>裂变拉新</div><div data-v-948ae362>通过红包、优惠券、实物等多种方式激励存量客户拉新，实现快速客户裂变</div></div><div class=\"cus-list\" data-v-948ae362><div data-v-948ae362>社群互动玩法</div><div data-v-948ae362>群打卡、群红包、群抽奖活动等丰富的群内互动玩法，再提升群活跃度，增强客户黏性的同时，实现社群增长</div></div><div class=\"cus-list\" data-v-948ae362><div data-v-948ae362>社交分销</div><div data-v-948ae362>激励种子用户充分利用自己的社交圈，实现流量，收益双裂变</div></div></div></div><div style=\"text-align:center;font-size:18px;padding:50px;\" data-v-948ae362>~该应用对所有企业免费使用，欢迎联系使用~</div>", 5);
import Cycle from "@/views/workWx/components/Cycle.vue";
const __default__ = {
  metaInfo: {
    title: "企微营销-京奇数据智慧营销",
    meta: [{
      name: "description",
      content: "京奇数据,业内领先的公域获客+私域获客,企微营销一体化闭环解决方案."
    }, {
      name: "keywords",
      content: "京奇数据,公域获客,私域获客，企微运营,客户运营"
    }],
    link: [{
      rel: "",
      href: ""
    }]
  }
};
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'index',
  setup(__props) {
    const list = [{
      title: '头部客户的共同选择',
      intro: '公私域打通的一体化智能营销产品+更具行业「know-how」的服务'
    }, {
      title: '连接全渠道数据',
      intro: '通过连接全局客户数据，帮助企业构建第一方客户池，打通全域数据和品牌营销价值链'
    }, {
      title: '一体化营销闭环',
      intro: '围绕数据、会员、社群、内容、场景的私域运营核心五元素，构建私域闭环营销场景'
    }];
    const getUrl = index => {
      return require(`../../assets/img/workWx/case${index}.png`);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _hoisted_3, _hoisted_4, _hoisted_5, _createElementVNode("div", _hoisted_6, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(list, (item, index) => {
        return _createElementVNode("div", {
          key: item,
          class: "list-card"
        }, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_7, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_8, _toDisplayString(item.intro), 1)]), _createElementVNode("img", {
          src: getUrl(index + 1),
          alt: "",
          class: "item-img hidden-xs-only"
        }, null, 8, _hoisted_9), _createElementVNode("img", {
          src: getUrl(index + 1 + 'H5'),
          alt: "",
          class: "item-img hidden-sm-and-up"
        }, null, 8, _hoisted_10)]);
      }), 64))]), _createVNode(Cycle), _hoisted_11]);
    };
  }
});